import styled, { css } from 'styled-components';
import devices from '../styles/devices';

const OutlinedText = styled.p`
  display: block;
  position: fixed;
  bottom: -20px;
  font-size: 27vw;
  font-weight: 800;
  line-height: 23vw;
  margin-bottom: 0;
  letter-spacing: -5px;
  color: transparent;
  z-index: -1;
  -webkit-text-stroke: ${({ theme }) => theme.colors.yellow} 2px;
  ::selection {
    color: ${({ theme }) => theme.colors.yellow};
  }

  ${({ onlyMobile }) =>
    onlyMobile &&
    css`
      @media (min-width: ${devices.mobile}) {
        display: none;
      }
    `};

  @media (min-width: ${devices.mobile}) {
    font-size: 120px;
    line-height: 100px;
  }

  @media (max-height: ${devices.mobile}) {
    display: none;
  }
`;

export default OutlinedText;
